export default __webpack_public_path__ + "static/media/X.5849e59e.svg";